'use strict';

angular.module('staticHtmlPageRoutes', ['staticHtmlPageControllers'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('staticHtmlPage', {
            url: '/Page/{page}',
            templateUrl: require('./Main.tpl.html'),
            controller: 'StaticHtmlPageController',
            resolve: {
                page: ['staticHtmlPageService', '$stateParams', function (service, $stateParams) {
                    return service.getPage($stateParams.page);
                }]
            }
        });
}]);